<template>
    <div v-if="dealer.rating" class="dealer-locator__result--rating">
        <span class="dealer-locator__result--rating-total">{{ dealer.rating.rating }}</span>
        <StarRating :rating="dealer.rating.rating" />
        <span class="dealer-locator__result--rating-count">({{ dealer.rating.userRatingCount }})</span>
    </div>
</template>

<script>
    import { defineComponent } from "vue";
    import StarRating from "./StarRating.vue";

    export default defineComponent({
        name: 'Rating',

        components: {
            StarRating
        },

        props: {
            dealer: Object
        }
    })
</script>